import React, { Component } from 'react';

class NewGroup extends Component {
    onDragOver(e) {
        e.preventDefault();
    }

    onDrop(e) {
        if (this.props.trackDragging !== undefined &&
           this.props.trackDragging.group !== this.props.group) {
            this.props.groups.newGroup(this.props.trackDragging);
            this.props.onGroupsChanged();
        }
    }

    render() {
        return (
            <div className="group">
              <div
                onDragOver={(e) => this.onDragOver(e)}
                onDrop={(e)=>{this.onDrop(e)}}                   
                draggable
                className="new-group-box">
                NEW GROUP
              </div>
            </div>
        );
    }
}

export default NewGroup;
